import { isAbsoluteUrl, parseOnifyApiUrl } from '@/utils/http-utils';
import { loadFiles } from '@/utils/load-files';
import { hCreateGenericErrorAlert } from '@/utils/create-generic-alerts';

/**
 * A Vue composable that provides utility functions.
 *
 * @function
 * @name useHUtils
 * @description
 * This composable provides a set of utility functions that can be used within a Vue application.
 * It includes functionalities to check if a URL is absolute, load files, and create a generic error alert.
 *
 * @returns {Object} An object containing the following methods:
 * - `hIsAbsoluteUrl`: A function to check if a URL is absolute.
 * - `hLoadFiles`: A function to load files.
 * - `hCreateGenericErrorAlert`: A function to create a generic error alert.
 */
export function useHUtils() {
  return {
    hIsAbsoluteUrl: isAbsoluteUrl,
    hLoadFiles: loadFiles,
    hCreateGenericErrorAlert,
  };
}

/**
 * A Vue composable that provides utility methods for Onify.
 *
 * @function
 * @name useOUtils
 * @description
 * This composable provides utility methods specifically for Onify API interactions.
 * It includes functionalities to parse Onify API URLs.
 *
 * @returns {Object} An object containing the following methods:
 * - `oParseUrl`: A function to parse Onify API URLs.
 */
export function useOUtils() {
  return {
    oParseUrl: parseOnifyApiUrl,
  };
}
